// Status and video rows of the debug overlay.
import { getLanguage } from '../i18n/index.js';
import { el, select, button } from './controls.js';

export function installStatusPanel({ overlay, stats, stream, backdrop, getAppState, log }) {
  const isStandalone = () =>
    window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;

  let permissionState = 'unknown';
  (async () => {
    try {
      const status = await navigator.permissions.query({ name: 'camera' });
      permissionState = status.state;
      status.onchange = () => {
        permissionState = status.state;
        log(`camera permission -> ${status.state}`);
      };
    } catch {
      permissionState = 'query unsupported';
    }
  })();

  overlay.row('Status', 'Build', () => __BUILD_TIME__);
  overlay.row('Status', 'App state', () => getAppState());
  overlay.row('Status', 'FPS', () => stats.fps.toFixed(0));
  overlay.row('Status', 'Viewport', () => `${stats.width}x${stats.height} @${stats.pixelRatio} (dpr ${window.devicePixelRatio})`);
  overlay.row('Status', 'Standalone', () => (isStandalone() ? 'yes' : 'no'));
  overlay.row('Status', 'Orientation', () => screen.orientation?.type ?? (innerHeight >= innerWidth ? 'portrait' : 'landscape'));
  overlay.row('Status', 'Language', () => getLanguage());
  overlay.row('Status', 'Camera permission', () => permissionState);

  overlay.row('Video', 'Stream', () => stream.status);
  overlay.row('Video', 'Video size', () => {
    const i = stream.getInfo();
    return i.width ? `${i.width}x${i.height} ready ${i.readyState}${i.paused ? ' paused' : ''}` : '-';
  });
  overlay.row('Video', 'Track', () => {
    const s = stream.getInfo().settings;
    return s.width ? `${s.width}x${s.height}@${s.frameRate ?? '?'} ${s.facingMode ?? ''}` : '-';
  });
  overlay.row('Video', 'Zoom / focus', () => {
    const s = stream.getInfo().settings;
    const c = stream.getInfo().capabilities;
    const z = c.zoom ? `zoom ${s.zoom ?? '?'} (${c.zoom.min}-${c.zoom.max})` : 'zoom n/a';
    const f = c.focusDistance ? `focus ${s.focusDistance ?? '?'}` : '';
    return `${z} ${f}`;
  });
  overlay.row('Video', 'Crop', () => `${backdrop.getInfo().crop}; ${backdrop.getInfo().fovNote}`);
  overlay.row('Video', 'Rotation', () => backdrop.getInfo().rotation);
  overlay.row('Video', 'Recoveries', () => stream.getInfo().recoveries);
  overlay.row('Video', 'Capabilities', () => {
    const keys = Object.keys(stream.getInfo().capabilities);
    return keys.length ? keys.join(' ') : '-';
  });
  overlay.row('Video', 'Last error', () => stream.getInfo().error || '-');

  const bar = el('div', { class: 'mw-bar' });
  bar.append('rotation ');
  bar.append(
    select(
      [
        ['auto', 'auto'],
        ['0', '0'],
        ['90', '90'],
        ['-90', '-90'],
      ],
      backdrop.rotationSetting,
      (v) => backdrop.setRotation(v),
    ),
  );
  bar.append(button('Re-acquire camera', () => stream.reacquire()));
  bar.append(button('Re-acquire (delayed)', () => stream.reacquireDelayed()));
  bar.append(button('Cycle resolution', () => stream.cycleResolution()));
  overlay.section('Video').append(bar);
}
